import { useEffect, useState } from "react";
import { vpAxios, money } from "../api";

const PERIODOS = [
  { key: "hoje", label: "Hoje" },
  { key: "ontem", label: "Ontem" },
  { key: "semana", label: "7 dias" },
  { key: "mes", label: "Este mês" },
];

export default function RelatoriosPage() {
  const [per, setPer] = useState("semana");
  const [data, setData] = useState(null);
  useEffect(() => { vpAxios.get(`/vaipede/relatorios?periodo=${per}`).then(r => setData(r.data)); }, [per]);

  return (
    <div data-testid="vaipede-relatorios">
      <div className="mb-6">
        <h1 className="text-2xl font-black">Relatórios</h1>
        <p className="text-sm text-neutral-500">Indicadores da sua operação</p>
      </div>
      <div className="flex gap-2 mb-6 flex-wrap">
        {PERIODOS.map(p => (
          <button key={p.key} onClick={() => setPer(p.key)} className={`px-4 py-2 rounded-full text-sm font-bold ${per === p.key ? "bg-[#EA1D2C] text-white" : "bg-white border border-neutral-200"}`}>
            {p.label}
          </button>
        ))}
      </div>

      {!data ? <p>Carregando...</p> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          <div className="bg-white rounded-2xl border border-neutral-200 p-5">
            <div className="text-xs text-neutral-500">Faturamento</div>
            <div className="text-2xl font-black mt-1 text-[#EA1D2C]">{money(data.faturamento)}</div>
          </div>
          <div className="bg-white rounded-2xl border border-neutral-200 p-5">
            <div className="text-xs text-neutral-500">Pedidos</div>
            <div className="text-2xl font-black mt-1">{data.pedidos}</div>
          </div>
          <div className="bg-white rounded-2xl border border-neutral-200 p-5">
            <div className="text-xs text-neutral-500">Ticket médio</div>
            <div className="text-2xl font-black mt-1">{money(data.ticket_medio)}</div>
          </div>
          <div className="bg-white rounded-2xl border border-neutral-200 p-5">
            <div className="text-xs text-neutral-500">Produto líder</div>
            <div className="text-lg font-black mt-1 truncate">{data.produto_lider}</div>
          </div>
        </div>
      )}
    </div>
  );
}
